export default __webpack_public_path__ + "static/media/0134.34ad1f84.jpg";